<template>
<div class="h-100 d-flex justify-center align-center">
  <AppCard class="w-50">
    <v-row>
      <v-col class="text-center">
        <h1>{{ $t('payment.PaymentSuccess.title') }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center">
        <app-material-icon name="check_circle" :size="100" color="success" />
      </v-col>
    </v-row>
  </AppCard>
</div>
</template>

<script>
import AppCard from '@/common/AppCard.vue'
export default {
  name: 'PaymentSuccess',
  components: { AppCard },
}
</script>
